import { IAssetDto } from 'api/odata/generated/entities/IAssetDto';
import { AddWorkOrder } from './AddWorkOrder';

export interface DownWorkOrderProps<TRow> {
  rows: TRow[];
  getAssets: (rows: TRow[]) => Promise<IAssetDto[]>;
  buttonName?: string;
  useSidePanel?: boolean;
}

export function DownWorkOrder<TRow>({
  rows,
  getAssets,
  buttonName,
  useSidePanel,
}: DownWorkOrderProps<TRow>) {
  return (
    <AddWorkOrder
      rows={rows}
      getAssets={getAssets}
      buttonName={buttonName}
      useSidePanel={useSidePanel}
      downtime={true}
    />
  );
}
